// extracted by mini-css-extract-plugin
export default {"search_order_input":"AdminSearch_search_order_input__1caRj","search_icon":"AdminSearch_search_icon__N29Op"};